/** @jsxRuntime classic */
/** @jsx jsx */
//@ts-nocheck
import { jsx } from '@emotion/react';
import camelcase from 'lodash.camelcase';
import React, { Component } from 'react';
import colors from '../../OrderEntry/css/colors';

import ButtonSpinner from '../../OrderEntry/ui/ButtonSpinner';
import highlight from '../../../components/Highlight';
import { SearchGlassIcon } from '../../OrderEntry/ui/icons';

const fieldWrap = {
  alignItems: 'center',
  border: '1px solid #e5e5ea',
  borderRadius: 5,
  color: colors.grey400,
  display: 'flex',
  height: 40,
  justifyContent: 'space-between',
  padding: '0 16px',
  width: '100%',
  '&:hover': {
    ' span': { color: colors.black },
    ' svg': { color: colors.black },
  },
  ' :focus-within': {
    border: `1px solid ${colors.blue}`,
    outline: 'none',
    color: colors.grey200,
    ' svg': { color: colors.blue },
  },
  ' input': {
    caretColor: colors.blue,
    width: '100%',
    height: '100%',
  },
};

const filterWrap = {
  backgroundColor: colors.white,
  left: 0,
  overflow: 'hidden',
  position: 'absolute',
  // top: 77,
  width: '100%',
  zIndex: '151',
  height: 0,
  transition: 'all 200ms ease-in-out',
  boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.15)'
};

const openFilter = {
  height: 280,
};

const innerDropDown = {
  border: `1px solid ${colors.grey400}`,
  borderRadius: 5,
  // marginTop: 8,
  maxHeight: 264,
  overflowY: 'scroll',
  padding: 16,
};

const tableRowWrap = {
  height: 80,
  display: 'flex',
  paddingLeft: 16,
  position: 'relative',
  '&:before': {
    position: 'absolute',
    top: 0,
    right: 0,
    borderRadius: 5,
    left: 0,
    width: '100%',
    content: '""',
    borderTop: `1px solid ${colors.grey300}`,
  },
  ':first-of-type': { '&:before': { borderTop: 'none' } },
  '&:hover': {
    borderRadius: 5,
    backgroundColor: colors.grey600,
    cursor: 'pointer',
    '&:before': { border: `1px solid ${colors.grey300}`, bottom: 0 },
    ' + div': { '&:before': { border: 'none' } },
  },
};

const cellWrap = {
  display: 'inline-flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: 134,
  ' span': { color: colors.grey500 },
};

export default class DropdownTable extends Component<any, any, any> {
  state = {
    searchValue: '',
  };

  matchTextSearch = value => {
    const { searchValue } = this.state;
    return value?.toLowerCase().includes(searchValue?.toLowerCase())
      ? { color: colors.orange200 }
      : '';
  };

  handleItemClick = (e, i) => {
    const { onClick, onItemClick } = this.props;
    onClick(e);
    onItemClick(i);
    this.setState({ searchValue: '' });
  };

  getRequiredStar = showRequired => {
    if (showRequired) {
      return <span style={{ color: ' #C50E29' }}>*</span>;
    }
    return '';
  };

  render() {
    const {
      isDropdown,
      itemList,
      label,
      width,
      styles,
      onTextChange,
      onClick,
      onItemClick,
      loadingStatus,
      showRequired,
      onBlur
    } = this.props;
    const fieldWidth = { width: width || 250 };
    return (
      <div css={[styles, fieldWidth, { position: 'relative' }]}>
        {label && (
          <div css={{ marginBottom: 8 }}>
            {label} {this.getRequiredStar(showRequired)}
          </div>
        )}
        <div css={fieldWrap} onClick={onClick}>
          <SearchGlassIcon />
          <input
            style={{background: 'transparent', border: 'none', outline: 'none'}}
            autoComplete="new-password"
            type="text"
            value={this.state.searchValue}
            name={camelcase(label)}
            onChange={(e: any) => {
              this.setState({searchValue: e.target.value});
              onTextChange(e);
            }}
            onBlur={(e) => onBlur && onBlur(e)}
          />
          {loadingStatus && (
            <span css={{ paddingBottom: 12, marginRight: 16 }}>
              <ButtonSpinner fill={colors.black} />
            </span>
          )}
        </div>
        {this.props.municipalityError && (
          <div style={{ fontFamily: 'IBM Plex Sans', color: '#C50E29' }}>
            Select municipality before saving the unvalidated property
          </div>
        )}
        {isDropdown && <div css={[filterWrap, isDropdown && openFilter]}>
          <div css={innerDropDown}>
            {itemList.map(i => (
              <div key={i.id}>
                <div
                  css={tableRowWrap}
                  onClick={e => this.handleItemClick(e, i)}
                >
                  <div css={cellWrap}>
                    <span>State</span>
                    <label>
                      {i.stateCode}
                    </label>
                  </div>
                  <div css={cellWrap}>
                    <span>County</span>
                    <label>
                     {highlight(i.county, this.state.searchValue)}
                    </label>
                  </div>
                  <div css={cellWrap}>
                    <span>{i.municipalityType}</span>
                    <label>
                       {highlight(i.municipality, this.state.searchValue)}
                    </label>
                  </div>
                  <div css={cellWrap}>
                  {i.subMunicipality && (
                    <React.Fragment>
                      <span>{i.subMunicipalityType}</span>
                      <label>
                         {highlight(i.subMunicipality, this.state.searchValue)}
                      </label>
                    </React.Fragment>
                  )}
                  {i.hamletName && (
                    <React.Fragment>
                      <span>Hamlet</span>
                      <label>
                        {highlight(i.hamletName, this.state.searchValue)}
                      </label>
                    </React.Fragment>
                  )}
                  </div>
                  {i.swisCode && (
                    <div css={cellWrap}>
                      <span>Swis Code</span>
                      <label>
                        {highlight(i.swisCode, this.state.searchValue)}
                      </label>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>}
      </div>
    );
  }
}
